const _excluded = ["className", "onCloseModal", "isLoading", "error", "style", "subscriptions", "refetch", "color"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '@adsk/alloy-react-box';
import { stylePropType } from '@adsk/alloy-react-theme';
import Modal from './components/Modal';
import { offeringPropType } from './helpers/types';
const SubscriptionsModalView = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      className,
      onCloseModal,
      isLoading,
      error,
      style,
      subscriptions,
      refetch,
      color: _color // this prop is ignored to fix an error with Flex getting wrong color type
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Flex, _extends({
    flexDirection: "row",
    className: className,
    style: style,
    ref: ref,
    "data-testid": "SubscriptionsModalView"
  }, props), /*#__PURE__*/React.createElement(Modal, {
    isLoading: isLoading,
    onClose: onCloseModal,
    error: error,
    subscriptions: subscriptions,
    onClickTryAgain: refetch
  }));
});
SubscriptionsModalView.displayName = 'SubscriptionsModalView';
SubscriptionsModalView.propTypes = {
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Closes modal*/
  onCloseModal: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  /** Styles applied to the root element */
  style: stylePropType,
  /**  User subscriptions and products*/
  subscriptions: PropTypes.arrayOf(offeringPropType.isRequired).isRequired,
  isLoading: PropTypes.bool.isRequired,
  refetch: PropTypes.func.isRequired
};
export default SubscriptionsModalView;
//# sourceMappingURL=SubscriptionsModalView.js.map